module.exports = __webpack_public_path__ + "img/avatar1.06bd6d68.png";